import type { ActivityfeedDataSlice } from './activityfeed.type'

export const activityfeedInitialState: ActivityfeedDataSlice = {
  activities: [],
  loading: false,
  error: null,
  lastFetchedProjectId: null,
}
